var exports = {
  "pd": "commentBox__yG3L6E",
  "jy": "errorBanner__SIyLO8",
  "FA": "CreateIssueFormWrapper__JxLQSE",
  "y$": "formGridContainer__CktSs5",
  "Yh": "mainContentSection__kUbwAV",
  "XU": "metadataSection__Ss8r3M",
  "wC": "footerButton__g3I_AB",
  "UM": "copilotWriteButton__CXGiaS",
  "$i": "footerArea__i4M6W5",
  "g3": "footerAreaIssueForm__Ntxrc6",
  "E7": "footerAreaDefault__Cnc93K",
  "CT": "formGridWithMetadata__C0eTyB",
  "pc": "duplicateDetectionStickyFooter__ny-hx6",
};

module.exports = exports;
